const s = "success-light", t = "danger-light", c = "default", n = "tertiary", o = "secondary", S = "danger", T = "success", A = "ghost", e = [s, t], E = [c, n, o, S, T, A, ...e], I = ["S", "M", "L"];
export {
  I as BUTTON_SIZES,
  S as DANGER,
  t as DANGER_LIGHT,
  c as DEFAULT,
  A as GHOST,
  e as LIGHT_VARIANTS,
  o as SECONDARY,
  T as SUCCESS,
  s as SUCCESS_LIGHT,
  n as TERTIARY,
  E as VARIANTS
};
